/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloseDeliveries200ResponseFailedInner
 */
export interface CloseDeliveries200ResponseFailedInner {
    /**
     * 
     * @type {string}
     * @memberof CloseDeliveries200ResponseFailedInner
     */
    brandId: string;
    /**
     * 
     * @type {string}
     * @memberof CloseDeliveries200ResponseFailedInner
     */
    company: string;
}

/**
 * Check if a given object implements the CloseDeliveries200ResponseFailedInner interface.
 */
export function instanceOfCloseDeliveries200ResponseFailedInner(value: object): value is CloseDeliveries200ResponseFailedInner {
    if (!('brandId' in value) || value['brandId'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    return true;
}

export function CloseDeliveries200ResponseFailedInnerFromJSON(json: any): CloseDeliveries200ResponseFailedInner {
    return CloseDeliveries200ResponseFailedInnerFromJSONTyped(json, false);
}

export function CloseDeliveries200ResponseFailedInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseDeliveries200ResponseFailedInner {
    if (json == null) {
        return json;
    }
    return {
        
        'brandId': json['brandId'],
        'company': json['company'],
    };
}

export function CloseDeliveries200ResponseFailedInnerToJSON(json: any): CloseDeliveries200ResponseFailedInner {
    return CloseDeliveries200ResponseFailedInnerToJSONTyped(json, false);
}

export function CloseDeliveries200ResponseFailedInnerToJSONTyped(value?: CloseDeliveries200ResponseFailedInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brandId': value['brandId'],
        'company': value['company'],
    };
}

